import { KText } from '@/ui-library/components';
import { Flex } from '@chakra-ui/react';
import { components } from 'react-select';

export const SchInterviewerGroupHeading = (props) => {
  const { data, viewTitle } = props ?? {};

  const { label } = data ?? {};

  return (
    <components.GroupHeading {...props}>
      <Flex justifyContent="space-between">
        <KText color="secondary-900" variant="overhead">
          {label}
        </KText>
        <KText
          pl="5px"
          isTruncated
          maxW="calc(100% - 10px)"
          variant="small_text"
          textTransform="none"
          enableTooltip
        >
          Interview load ({viewTitle ?? '-'})
        </KText>
      </Flex>
    </components.GroupHeading>
  );
};
